<template lang="html">
<div class="feedback-game" v-show="showFeedback">
    <div v-if="correct">
      <h1 class="correct_result container text-center align-center column">
        <i class="far fa-check-circle"></i>
        <span>That's right!</span>
      </h1>
    </div>
    <div v-else>
      <h1 class="wrong_result container text-center align-center column">
        <i class="far fa-times-circle"></i>
        <span>Oops! Wrong choice!</span>
      </h1>
    </div>

</div>
</template>

<script>
export default {
  props: {
    correct: {
      type: Boolean
    },
    finish: {
      type: Boolean
    }
  },
  data() {
    return {
      showFeedback: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import './src/assets/css/base/variables';

.feedback-game {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background: rgba(255,255,255,.9);
    h1 {
      &.correct_result,
      &.wrong_result {
        font-weight: bold;
      }

      &.correct_result {
        color: $color-green !important;
      }

      &.wrong_result {
        color: $color-red !important;
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/game/feedback/index.vue